var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotSaved(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 157,
    viewBox: "0 0 157 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.5 147.188C116.435 147.188 147.188 116.435 147.188 78.5C147.188 40.5649 116.435 9.8125 78.5 9.8125C40.5649 9.8125 9.8125 40.5649 9.8125 78.5C9.8125 116.435 40.5649 147.188 78.5 147.188Z",
    fill: "#D3EDEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5 98.125C77.1988 98.125 75.9509 97.6081 75.0308 96.688C74.1107 95.7679 73.5938 94.52 73.5938 93.2188V44.1562C73.5938 42.855 74.1107 41.6071 75.0308 40.687C75.9509 39.7669 77.1988 39.25 78.5 39.25C79.8012 39.25 81.0491 39.7669 81.9692 40.687C82.8893 41.6071 83.4062 42.855 83.4062 44.1562V93.2188C83.4062 94.52 82.8893 95.7679 81.9692 96.688C81.0491 97.6081 79.8012 98.125 78.5 98.125Z",
    fill: "url(#paint0_linear_682_17224)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5 117.75C81.2096 117.75 83.4062 115.553 83.4062 112.844C83.4062 110.134 81.2096 107.938 78.5 107.938C75.7904 107.938 73.5938 110.134 73.5938 112.844C73.5938 115.553 75.7904 117.75 78.5 117.75Z",
    fill: "url(#paint1_linear_682_17224)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_682_17224",
    x1: 76.1842,
    y1: 8.92718,
    x2: 87.5529,
    y2: 9.5395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0004B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_682_17224",
    x1: 76.1842,
    y1: 102.884,
    x2: 86.5078,
    y2: 106.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0004B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSaved);
export default __webpack_public_path__ + "static/media/notSaved.8ad2edb5856192fa2dd789f6279875db.svg";
export { ForwardRef as ReactComponent };